import { useRouter } from "expo-router";
import React, { useEffect } from "react";
import { Image, Platform, ScrollView, Text, TouchableOpacity, View } from "react-native"; // 💡 1. เพิ่ม Import Platform
import Icon from "react-native-vector-icons/FontAwesome";
import { useDispatch, useSelector } from "react-redux";
import { getScale } from "../redux/actions/masteractions";
import { useLanguage } from "./LanguageProvider";

export default function home() {
  const router = useRouter();
  const dispatch = useDispatch();
  const scale = useSelector((state: any) => state?.master?.scale) || null;
  const { t } = useLanguage();

  useEffect(() => {
    dispatch(getScale() as any);
  }, []);

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
            paddingBottom: 120,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[85%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
            <Text className="text-2xl font-kanit py-2">
              {t("select_weight_point")}
            </Text>
          </View>

          {scale && Object.keys(scale).map((factoryKey, factoryIndex) => (
            <View
              key={factoryIndex}
              className="w-full items-start justify-start pt-2"
            >
              <Text className="text-lg text-gray-500 font-kanit py-1">
                {factoryKey}
              </Text>

              {scale[factoryKey]?.map((item: any, index: number) => (
                <View
                  key={index}
                  className="w-full flex-row items-center justify-between py-2 rounded-xl bg-gray-100 px-4 mt-3"
                >
                  <View className="flex flex-row items-center justify-center py-1">
                    {/* 💡 2. ผ่าตัดปรับจุดแสดงผลรูปภาพตาชั่งให้เสถียรบนเว็บ */}
                    <Image
                      source={require("../../assets/scale.png")}
                      resizeMode="contain"
                      style={{
                        width: Platform.OS === 'web' ? 56 : 48,  // 56px สอดคล้องกับ w-14 ของเดิม
                        height: Platform.OS === 'web' ? 56 : 48,
                        borderRadius: Platform.OS === 'web' ? 28 : 24,
                      }}
                    />
                    <View className="flex flex-col items-start justify-center ml-3">
                      <Text className="text-xl font-kanit">
                        {item.machine_code}
                      </Text>
                      <View className="flex flex-row items-center justify-start">
                        <Icon name="map-marker" size={18} color="#58d68d" />
                        <Text className="text-md font-kanit text-gray-500">
                          {" "}
                          {item.machine_name}
                        </Text>
                      </View>
                    </View>
                  </View>

                  <TouchableOpacity
                    onPress={() =>
                      router.push({
                        pathname: "/screens/order_scales",
                        params: { machine_code: item.machine_code, item: JSON.stringify(item) },
                      })
                    }
                    className="rounded-full bg-[#58d68d] py-2.5 px-4 items-center shadow-sm justify-center"
                  >
                    <Text className="text-white text-sm font-kanit pt-1">
                      {t("items")}
                    </Text>
                  </TouchableOpacity>
                </View>
              ))}
            </View>
          ))}
        </ScrollView>
      </View>
    </>
  );
}